module.exports = __webpack_public_path__ + "static/media/peo_plus_quote_image.7830433e.jpeg";